const fmt = (s) => new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric" });

export const PromoList = ({ promos = [], className = "" }) => {
  if (!promos.length) return null;
  const now = new Date().toISOString();
  return (
    <ul className={`space-y-2 border-t border-[#F59E0B]/20 pt-3 ${className}`} data-testid="invite-promotions">
      {promos.map((p) => (
        <li key={p.id} className="text-sm leading-relaxed text-[#C9BFAE]" data-testid={`invite-promo-${p.id}`}>
          <span className="font-medium text-[#FBBF24]">{p.title}</span>
          <span> · {p.start <= now ? "now" : `from ${fmt(p.start)}`} until {fmt(p.end)}</span>
          {p.description && <span className="block text-[#D6CCBC]">{p.description}</span>}
          {p.link && <a href={p.link} target="_blank" rel="noreferrer" className="text-[#F59E0B] hover:underline" data-testid={`invite-promo-link-${p.id}`}>Details</a>}
        </li>
      ))}
    </ul>
  );
};
